<template>
  <!-- Not Used -->
  <div class="page-layout blank contacts-manage">
    <div class="pb-10">
      <h2 class="headerblock">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
          </div>
          <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
            <div class="breadcome-heading d-none d-xl-inline">
              <div class="form-group formsearch has-warning has-feedback">
                <input type="text" class="form-control textremove holder" id="inputWarning2" aria-describedby="inputWarning2Status" v-model="searchkey" placeholder="Search...">
                <!-- <span class="icon-close-circle-outline form-control-feedback-cancel" aria-hidden="true" ></span> -->
                <!-- <span class="icon-magnify iconsearch form-control-feedback" aria-hidden="true"></span> -->

                <span class="icon-magnify iconsearch form-control-feedback" aria-hidden="true" v-if="searchkey.length <= 0"></span>
                <span class="icon-close form-control-feedback iconclose" aria-hidden="true" v-if="searchkey.length >= 1" @click="ClearSearch()"></span>
              </div>
            </div>
            <router-link :disabled="!$routerHistory.hasForward()" :to="{ path: $routerHistory.next().path }">
              <el-tooltip class="item pull-right" effect="dark" content="Click to Go Forward" placement="top">
                <button class="btn btn-new-grey btn-fab-dc mr-3">
                  <i class="icons icon-arrow-right"></i>
                </button>
              </el-tooltip>
            </router-link>
            <router-link :disabled="!$routerHistory.hasPrevious()" :to="{ path: $routerHistory.previous().path }">
              <el-tooltip class="item pull-right" effect="dark" content="Click to Go Back" placement="top">
                <button class="btn btn-new-grey btn-fab-dc mr-3">
                  <i class="icons icon-arrow-left"></i>
                </button>
              </el-tooltip>
            </router-link>
          </div>
        </div>
      </h2>
      <div class="page-layout carded left-sidebar">
        <div class="page-content-wrapper" style="padding: 0 0rem;">
          <div class="page-content custom-scrollbar">
            <div class="cover-pic row">
              <img :src="userProfile" class="h-100 w-100">
              <!-- <div class="mt-3 fs-14 pl-3 pt-1 pointer custom-background-upload">
                                <label class=" icon icon-picture textWhite d-block fs-14 pr-1 w-100 pointer">
                                    <input type="file" @change="onUserBackground">
                                    <span class="ml-3" style="font-family:'Poppins', sans-serif;">Change Picture</span>
                                </label>
                            </div> -->
              <div class="row align-items-center">
                <img class="avatar huge coverPicIcon" :src="userData.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'">
                <!-- <div class="mediaIcon">
                                    <i class="icon icon-facebook textWhite contactMedia mediaFacebook"></i>
                                    <i class="icon icon-twitter textWhite contactMedia mediaTwitter ml-2"></i>
                                    <i class="icon icon-linkedin textWhite contactMedia mediaLinkedIn ml-2"></i>
                                    <i class="icon icon-skype textWhite contactMedia mediaSkype ml-2"></i>
                                </div> -->
              </div>
              <!-- <div class="editProfile fs-14 pl-2 pt-1 pointer" @click="showEditContact()">
                                <span class="icon icon-pencil textWhite fs-14 pr-1"></span>
                                Edit Profile
                            </div> -->
            </div>
            <el-container>
              <el-aside class="contactSidebar">
                <div class="header pt-4">
                  <div>
                    <div class="contactInfo mt-8">
                      <div>
                        <span class="defaultBlue fw-600 fs-18 contactTitle">{{ userData.full_name }}</span>
                        <div class="mt-2 contactTitle">
                          <img class="CompanyContact mr-1 mb-1" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/envelope-grey.svg">
                          <span>
                            {{ userData.primary_email }}
                          </span>
                        </div>
                        <div class="mt-2 contactTitle">
                          <img class="CompanyContact" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/Phone-icon-grey.svg">
                          <span>
                            {{ userData.primary_phone.phone_number }}
                          </span>
                        </div>
                        <div class="text-center mt-4 mb-3">
                            <!-- <i class="icon icon-facebook defaultBlue contactMediaView mediaFacebook" style="font-size: 16px;width: 16px;height: 16px;line-height: 16px;"></i>
                            <i class="icon icon-twitter defaultBlue contactMediaView mediaTwitter ml-2" style="font-size: 16px;width: 16px;height: 16px;line-height: 16px;"></i>
                            <i class="icon icon-skype defaultBlue contactMediaView mediaSkype ml-2" style="font-size: 16px;width: 16px;height: 16px;line-height: 16px;"></i> -->
                        </div>

                        <div class="qrcode-block-view mt-3">
                          <img src="/static/images/qr-logo-dg.svg" class="qr-logo-view">
                          <qrcode-vue :value="valueqr" :size="size" level="H" background="#d6e2ef" foreground="#00448b" class="qrcode-content-view"></qrcode-vue>
                        </div>
                        <div class="mt-6 contactTitle" v-if="loggedInUser.id!=$route.params.id">
                          <div class="">
                            <a class="btn btn-warning btn-smm text-white mx-4 mb-3" v-if="connectionStatus.connection_status=='pending'&&connectionStatus.sent_by==loggedInUser.id&&account==connectionStatus.sender_company&&connectionStatus.sent_to==$route.params.id" @click="changeConnectionStatus('delete',connectionStatus._id)">Request Sent</a>
                            <a class="btn btn-danger btn-smm mx-4 mb-3" v-else-if="connectionStatus.connection_status=='connected'" @click="changeConnectionStatus('disconnected', connectionStatus._id)">Disconnect</a>
                            <a class="btn btn-outline-success btn-smm text-success mx-4 mb-3" v-else-if="connectionStatus.connection_status=='pending'&&connectionStatus.sent_to==loggedInUser.id&&account==connectionStatus.receiver_company&&connectionStatus.sent_by==$route.params.id" @click="changeConnectionStatus('connected',connectionStatus._id)">Pending</a>
                            <a class="btn btn-success btn-smm text-white mx-4 mb-3" v-else @click="addConnection()">Connect</a>
                            <!-- <a class="btn btn-secondary btn-smm mx-4 mb-3">Follow</a> -->
                            <!-- <a class="btn btn-secondary btn-smm mx-4 mb-3">Unfollow</a> -->
                          </div>
                        </div>
                      </div>
                      <hr class="mt-6 mb-6">
                      <contact-suggestions></contact-suggestions>
                      <!-- <div class="mt-8">
                          <div>
                              <ul class="nav flex-column">
                                  <li class="nav-item">
                                      <a class="nav-link verticalTab" :class="{contactActiveTab : contactTimeline == true}" @click="timelineInfoTab()">Timeline</a>
                                  </li>
                                  <li class="nav-item">
                                      <a class="nav-link verticalTab" :class="{contactActiveTab : contactAbout == true}" @click="aboutInfoTab()">About</a>
                                  </li>
                                  <li class="nav-item">
                                      <a class="nav-link verticalTab" :class="{contactActiveTab : contactDeals == true}" @click="dealsInfo()">Deals</a>
                                      <a class="nav-link verticalTab" href="javascript:;">Deals</a>
                                  </li>
                                  <li class="nav-item">
                                      <a class="nav-link verticalTab" :class="{contactActiveTab : contactUpcomingEvents == true}" @click="companyEventsInfo()">Upcoming Events</a>
                                      <a class="nav-link verticalTab" href="javascript:;">Upcoming Events</a>
                                  </li>
                              </ul>
                          </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </el-aside>
              <el-main class="contactTabs">
                <div class="row">
                  <div class="col-lg-12">
                    <el-tabs class="contact-details-tab-view" :stretch="true" v-model="contactActivity">
                      <el-tab-pane name="first">
                        <span slot="label">
                          <img class="activityContact pr-2" src="/static/images/crm/icons/basic.svg">
                          Basic Information
                        </span>
                        <personal-info-view :userData='userData'></personal-info-view>
                      </el-tab-pane>
                      <el-tab-pane>
                        <span slot="label">
                          <img class="activityContact pr-2" src="/static/images/crm/icons/communication.svg">
                          Communication
                        </span>
                        <contact-communication-view :userData='userData'></contact-communication-view>
                      </el-tab-pane>
                      <el-tab-pane>
                        <span slot="label">
                          <img class="activityContact pr-2" src="/static/images/crm/icons/marker.svg">
                          Address
                        </span>
                        <contact-address-view :userData='userData'></contact-address-view>
                      </el-tab-pane>
                      <el-tab-pane>
                        <span slot="label">
                          <img class="activityContact pr-2" src="/static/images/crm/icons/preference.svg">
                          Preference
                        </span>
                        <preference-view :userData='userData'></preference-view>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                </div>
              </el-main>
            </el-container>
          </div>
        </div>
      </div>
    </div>
    <!-- <div>
      <edit-contact edit_contact="edit-contact-modal"></edit-contact>
    </div>
    <div>
      <select-map modal_name="edit_address_modal"></select-map>
    </div> -->
  </div>
</template>
<script>
import { User } from "./mixins/user";
import { EventBus } from "./eventBus/nav-bar-event.js";
import PersonalInfoView from "./PersonalInfoView";
import ContactCommunicationView from "./ContactCommunicationView";
import ContactAddressView from "./ContactAddressView";
import PreferenceView from "./PreferenceView";
import myUpload from "vue-image-crop-upload";
import SelectMap from "./SelectMap";
import QrcodeVue from "qrcode.vue";
import ContactSuggestions from "./ContactSuggestions";
export default {
  data() {
    return {
      backToPrevious: true,
      toggleSideBar: false,
      contactTimeline: true,
      contactAbout: false,
      contactDeals: false,
      contactUpcomingEvents: false,
      show: false,
      userProfile:
        "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/coverpic3.jpg",
      headers: {
        smail: "*_~",
      },
      contactActivity: "first",
      contactInfo: "first",
      valueqr: "https://example.com",
      size: 90,
      connectionStatus: { connection_status: null },
      searchkey: "",
    };
  },
  mixins: [User],
  components: {
    PersonalInfoView,
    ContactCommunicationView,
    ContactAddressView,
    PreferenceView,
    "my-upload": myUpload,
    SelectMap,
    QrcodeVue,
    ContactSuggestions,
  },
  props: ["userData"],
  methods: {
    toggleBtn() {
      this.toggleSideBar = !this.toggleSideBar;
    },
    toggleBtn1() {
      this.toggleSideBar = false;
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(userProfile, field) {
      // console.log("-------- crop success --------");
      this.userProfile = userProfile;
    },
    cropUploadSuccess(jsonData, field) {
      // console.log("-------- upload success --------");
      // console.log(jsonData);
      // console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      // console.log("-------- upload fail --------");
      // console.log(status);
      // console.log("field: " + field);
    },
    showEditMap() {
      this.$modal.show("edit_address_modal");
      // console.log('Show Contact Map');
    },
    onUserBackground(e) {
      const file = e.target.files[0];
      this.userProfile = URL.createObjectURL(file);
    },
    ClearSearch() {
      this.searchkey = "";
    },
    async checkEmployeeExists(){
        let response = await this.checkIfEmployeeExists();
        this.employeeData = response
    }
  },
  created() {
    this.GetUserData(this.$route.params.id);
    this.getConnectionStatus();
  },
  mounted() {
    EventBus.$emit("contactdetailsLoad", true);
    EventBus.$emit("companydetailsLoad", false);
    EventBus.$emit("dashboardLoad", false);
    EventBus.$emit("leadsLoad", false);
    EventBus.$emit("productsLoad", false);
    EventBus.$emit("emailLoad", false);
    EventBus.$emit("dealsLoad", false);
    EventBus.$emit("noteLoad", false);
  },
  computed: {
    loggedInUser() {
      return this.$store.getters.loggedInUser;
    },
    account() {
      return this.$store.getters.account;
    },
  },
  beforeRouteUpdate(to, from, next) {
    const id = to.params.id;
    this.GetUserData(id);
    next();
  },
};
</script>
<style>
.back-tooltip .popper__arrow {
  left: 60px !important;
}

@media screen and (min-width: 500px) and (max-width: 576px) {
  .hideBackToPrevious {
    display: none;
  }
}

@-moz-document url-prefix() {
  .coverPicIcon {
    margin-top: 123px;
  }

  .mediaIcon {
    top: 19% !important;
  }
}

.contactInfo {
  margin-top: 10px;
  display: block;
  justify-content: center;
  align-items: center;
  margin-bottom: 3%;
  position: relative;
}

.companyBackground {
  border-right: solid 1px #94bef0;
  background-image: linear-gradient(
    to bottom,
    #eaeaec,
    #f7f7f8 15%,
    #ffffff 34%,
    #ffffff 48%,
    #ffffff 62%,
    #f7f7f8 85%,
    rgba(234, 234, 236, 0.8)
  );
}

.CompanyContact {
  width: 14.2px;
  height: 10.8px;
}

.headerTitleView {
  width: 357px;
  height: 40px;
  border-radius: 100px;
  background-color: #f2f2f2;
  margin-top: 15px;
  display: inline-block;
}

.contactActiveTab {
  color: #00448b !important;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  border-right: solid 18px #cdd2da;
  background-color: #f1f1f1;
  border-right-color: #ffffff;
  overflow: inherit !important;
  padding-left: 45px !important;
}

.info:hover {
  color: #00448b;
}

.info {
  margin-right: 40px;
}

.a-q-Jc-Pj-Ya-contactView {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  line-height: 30px;
}
.a-q-Jc-Pj-Ya-contactView {
  line-height: 25px;
  padding: 16px 10px 16px 15px;
  /* border-bottom: solid 1px #707070; */
}

.a-q-Jc-Lb-contactView {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-flex: 1 1 auto;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  text-decoration: none;
  line-height: 1.21;
  letter-spacing: normal;
  color: #303031;
  margin-left: 88px;
}

.a-q-Jc-Pj-Ya-contactView:nth-of-type(even) {
  background-color: #f5f6f9;
}

.a-q-Jc-Lb-contactView.linkactive {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: right;
  color: #00448b;
}

.a-q-Jc-wg-contactView {
  text-decoration: none;
}

.suggestionCompany {
  width: 48px;
  height: 48px;
}

@media screen and (max-width: 991px) {
  .suggestions {
    display: none !important;
  }
}

@media screen and (max-width: 764px) {
  .companyDisplay {
    display: none !important;
  }
}

.textWhite {
  color: white;
}

.contactMediaView {
  font-size: 18px !important;
  padding-top: 3px !important;
  cursor: pointer;
  padding-left: 3px;
}

.mediaFacebook:hover {
  color: RGB(0, 132, 255) !important;
}

.mediaTwitter:hover {
  color: #1da1f2 !important;
}

.mediaLinkedIn:hover {
  color: #0077b5 !important;
}

.mediaSkype:hover {
  color: #0077b5 !important;
}

.verticalTab {
  height: 41px;
  display: flex;
  width: 100%;
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 24px;
  position: relative;
  justify-content: center;
}

.contactSidebar {
  overflow-x: hidden;
  width: 312.7px;
  /* border-right: solid 1px #cdd2da; */
  background-image: linear-gradient(
    to bottom,
    #eaeaec,
    #f7f7f8 15%,
    #ffffff 34%,
    #ffffff 48%,
    #ffffff 62%,
    #f7f7f8 85%,
    rgba(234, 234, 236, 0.8)
  );
}

.contactTitle {
  text-align: center;
  display: block;
}

.elTab {
  overflow-x: hidden !important;
}

.editProfile {
  float: right;
  right: 25px;
  top: 135px;
  position: absolute;
  color: #ffffff;
  border-radius: 50px;
  width: 112.5px;
  height: 33.2px;
  border: solid 1px rgba(0, 0, 0, 0.4);
  background-color: rgba(0, 0, 0, 0.2);
}

.activityContact {
  width: 26px;
  height: 19px;
  margin-bottom: 4px !important;
}

.contact-details-tab-view.el-tabs--border-card > .el-tabs__header {
  background-color: #fff !important;
  border-right: none !important;
  color: #00448b;
}

.contact-details-tab-view
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item.is-active {
  border-right-color: #ffffff !important;
  border-left-color: #ffffff !important;
  border-bottom-color: #00448b;
}

.contact-details-tab-view
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item {
  color: #00448b !important;
}

.contact-details-tab-view .el-tabs__item {
  color: #303031 !important;
}

.el-main.contactTabs {
  padding-top: 0px !important;
  padding-left: 6px !important;
  margin-left: -2px;
  border-left: solid 1px #cdd2da;
  padding-right: 20px !important;
  padding-bottom: 20px !important;
}

.email-ul.dc-menu--horizontal {
  height: 42px;
  background-color: #f5f6f9;
}

.email-ul.dc-menu--horizontal > .dc-menu-item {
  height: 42px !important;
  line-height: 42px !important;
  margin: 0;
}

.email-ul .nav-link {
  height: 42px !important;
  /* background-color: #f5f6f9; */
}

.email-ul .nav-link:hover {
  background-color: none !important;
}

.email-inputs {
  padding-left: 100px;
  padding-right: 100px;
}

.aboutHeading {
  display: flex;
  width: 100%;
  padding-top: 8px;
  padding-left: 22px;
}
input[type="file"] {
  display: none;
}
.el-main.contactTabs {
  padding-top: 0px !important;
  padding-left: 6px !important;
  margin-left: -2px;
  border-left: solid 1px #cdd2da;
  padding-right: 20px !important;
  padding-bottom: 20px !important;
}
.contactSidebar {
  border-right: 0px solid #94b3f0 !important;
}

.qrcode-block-view {
  border-radius: 6px;
  width: 104px;
  height: 105px;
  position: relative;
  display: inline-block;
  display: block;
  margin: 0 auto;
  border: 1px solid #00448b;
  background: #d6e2ef;
}
.qrcode-content-view {
  text-align: center;
  margin: 6px auto;
  background: #d6e2ef !important;
}
.qr-logo-view {
  position: absolute;
  margin-top: 40px;
  margin-left: 35px;
  width: 30px;
}
.contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 15px 5px 5px !important;
}
.contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content {
  top: 10px;
}

.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-firstblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-secondblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__header.is-top
  .el-tabs__nav-wrap
  .el-tabs__nav
  .el-tabs__active-bar {
  height: 3px;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__header.is-top
  .el-tabs__nav-wrap
  .el-tabs__nav-scroll {
  padding: 0 8px !important;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__header.is-top
  .el-tabs__nav-wrap
  .el-tabs__nav
  .el-tabs__item {
  padding: 2px 20px;
  height: 45px;
  line-height: 45px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProfilePageUser.vue